export const events = {
  Unauthorized: "unauthorized",
  AddReferral: "add_referral"
};
